import monitorTypes from './types/monitor'
import monitorService from '@/api/monitor'

const state = {}

const actions = {
  /**
   * 获取超讯限水位的测站点
   */
  [monitorTypes.GET_STATISTICS_RAIN] ({ commit }, { sID = '22', StationName = '', mainStation = false, aDDVCD = '', appType = '', beginTime = '', endTime = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getStatisticsRain({ sID, aDDVCD, mainStation, StationName, appType, beginTime, endTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取行政区划
   */
  [monitorTypes.GET_ADCD] ({ commit }, { isTown = '', parentAdcdCode = '', searchName = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getAdcd({ isTown, parentAdcdCode, searchName, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水库水位
   */
  [monitorTypes.GET_STATISTICS_RESERVOIR_WATER] ({ commit }, { sID = '22', mainStation = false, STID = '', time = '', aDDVCD = '', stationName = '', orderField = '', desc = true, reservoirScale, date }) {
    return new Promise((resolve, reject) => {
      monitorService.getStatisticsReservoirWater({ sID, mainStation, STID, aDDVCD, stationName, orderField, desc, reservoirScale, date, time }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 河道水位
   */
  [monitorTypes.GET_STATISTICS_RIVER_WATER] ({ commit }, { sID = '22', aDDVCD = '', mainStation = false, stationName = '', orderField = '', desc = true }) {
    return new Promise((resolve, reject) => {
      monitorService.getStatisticsRiverWater({ sID, aDDVCD, mainStation, stationName, orderField, desc }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 时段雨量
   */
  [monitorTypes.GET_HOURLY_RAINFALL_INFO] ({ commit }, { sID = '22', sTID = '', beginTime = '', endTime = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getHourlyRainfallInfo({ sID, sTID, beginTime, endTime, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 日雨量
   */
  [monitorTypes.GET_DAILY_RAINFALL_INFO] ({ commit }, { sID = '22', sTID = '', beginDate = '', endDate = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getDailyRainfallInfo({ sID, sTID, beginDate, endDate, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 月雨量
   */
  [monitorTypes.GET_MONTHLY_RAINFALL] ({ commit }, { sID = '22', sTID = '', beginDate = '', endDate = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getMonthlyRainfall({ sID, sTID, beginDate, endDate, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 年雨量
   */
  [monitorTypes.GET_YEARLY_RAINFALL] ({ commit }, { sID = '22', sTID = '', beginDate = '', endDate = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getYearlyRainfall({ sID, sTID, beginDate, endDate, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 综合雨水情（所有，江河，水库）
  [monitorTypes.GET_SYNTHETICAL_WATERANDRAIN] ({ commit }, { sID = '22', STID = '', aDDVCD = '', type = '', stationName = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getSyntheticalWaterAndRain({ sID, STID, aDDVCD, type, stationName, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 综合雨水情（雨量）
  [monitorTypes.GET_SYNTHETICAL_RAIN] ({ commit }, { sID = '22', aDDVCD = '', beginTime = '', endTime = '', stationName = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getSyntheticalRain({ sID, aDDVCD, beginTime, endTime, stationName, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取单个视频监控地址
   */
  [monitorTypes.GET_VIDEOMONITOR_URL] ({ commit }, { name = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getVideoMonitorUrl({ name }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取全部视频监控数据
   */
  [monitorTypes.GET_MONITOR_STATIONS] ({ commit }) {
    return new Promise((resolve, reject) => {
      monitorService.getMonitorStations().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出实时雨情
   */
  [monitorTypes.EXPORT_REALTIME_RAIN] ({ commit }, { sID = '22', aDDVCD = '', appType = '', beginTime = '', endTime = '', stationName = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportRealTimeRain({ sID, aDDVCD, appType, beginTime, endTime, stationName, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出河道水情
   */
  [monitorTypes.EXPORT_RIVER_WATER] ({ commit }, { sID = '22', aDDVCD = '', stationName = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportRiverWater({ sID, aDDVCD, stationName, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出水库水情
   */
  [monitorTypes.EXPORT_RESERVOIR_WATER] ({ commit }, { sID = '22', aDDVCD = '', stationName = '', mainStation = '', reservoirScale = '', time = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportReservoirWater({ sID, aDDVCD, stationName, mainStation, reservoirScale, time }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出雨量统计-时段雨量
   */
  [monitorTypes.EXPORT_RAINSTATIS_HOURLY] ({ commit }, { sID = '22', sTID = '', beginTime = '', endTime = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportRainStatisHourly({ sID, sTID, beginTime, endTime, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出雨量统计-日雨量
   */
  [monitorTypes.EXPORT_RAINSTATIS_DAILY] ({ commit }, { sID = '22', sTID = '', beginDate = '', endDate = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportRainStatisDaily({ sID, sTID, beginDate, endDate, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出雨量统计-月雨量
   */
  [monitorTypes.EXPORT_RAINSTATIS_MONTHLY] ({ commit }, { sID = '22', sTID = '', beginDate = '', endDate = '', monthType = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportRainStatisMonthly({ sID, sTID, beginDate, endDate, monthType, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出雨量统计-年雨量
   */
  [monitorTypes.EXPORT_RAINSTATIS_YEARLY] ({ commit }, { sID = '22', sTID = '', beginDate = '', endDate = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportRainStatisYearly({ sID, sTID, beginDate, endDate, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [monitorTypes.GET_RAIN_WATER_TOTAL] ({ commit }, { sID = '22', sTID = '', time = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getRainWaterTotal({ sID, sTID, time }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [monitorTypes.GET_RAINWATERMINUTESTOTAL] ({ commit }, { sID = '22', sTID = '', time = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getRainWaterMinutesTotal({ sID, sTID, time }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [monitorTypes.GET_ALLRAINFALL] ({ commit }, { sid = '', addvcd = '', begTime = '', endTime, mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.getAllRainfall({ sid, addvcd, begTime, endTime, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 全区降雨量导出
  [monitorTypes.EXPORT_ALLRAINFALL] ({ commit }, { sID = '22', addvcd = '', begTime = '', endTime, mainStation = '' }) {
    return new Promise((resolve, reject) => {
      monitorService.exportAllRainfall({ sID, addvcd, begTime, endTime, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // // 台风
  // [monitorTypes.GET_TYHOON_ACTIVITY] ({ commit }, { tfid = '' }) {
  //   return new Promise((resolve, reject) => {
  //     monitorService.getTyhoonActivity({ tfid }).then(res => {
  //       resolve(res.data)
  //     }).catch(err => reject(err))
  //   })
  // },
  [monitorTypes.GET_RAIN_WATER_REPORT] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      monitorService.getRainWaterReport(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [monitorTypes.GET_RAIN_WATER_REPORT_EXPORT] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      monitorService.getRainWaterReportExport(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
